<template>
	<div
		class="quantity-control"
		data-quantity=""
	>
		<button
			class="quantity-btn"
			data-quantity-minus=""
			:disabled="loading"
			@click="handleDecrement"
		>
			<FontAwesomeIcon :icon="['far', 'minus']" />
		</button>
		<FontAwesomeIcon
			v-if="loading"
			:icon="['far', 'circle-notch']"
			class="loader"
		/>
		<input
			v-else
			:value="quantityLocal"
			type="number"
			class="quantity-input"
			data-quantity-target=""
			step="1"
			min="1"
			max=""
			name="quantity"
			@blur="handleBlur"
			@input="handleInput"
		/>
		<button
			class="quantity-btn"
			:disabled="loading || (!!maxVal && maxVal <= value)"
			data-quantity-plus=""
			@click="handleIncrement"
		>
			<FontAwesomeIcon :icon="['far', 'plus']" />
		</button>
	</div>
</template>

<script>
// import EditableField from '@/components/Essentials/EditableField'
export default {
	name: 'BaseQuantitySelect',
	components: {
		// EditableField
	},
	props: {
		value: {
			type: Number,
			default: 1
		},
		maxVal: {
			type: Number,
			default: null
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			quantityLocal: this.value
		}
	},


	watch: {
		value (val) {
			this.quantityLocal = val || 1
		}
	},

	methods: {
		handleEmitInput (val) {
			this.$emit('input', val)
		},


		handleInput (e) {
			this.quantityLocal = parseInt(e?.target?.value)
		},

		handleBlur () {
			if (this.quantityLocal <= 0) {
				this.quantityLocal = 1
			} else {
				this.quantityLocal = this.maxVal && this.maxVal < this.quantityLocal ? this.maxVal : this.quantityLocal
			}

			if (this.value !== this.quantityLocal) {
				this.handleEmitInput(this.quantityLocal)
			}
		},

		handleIncrement () {
			this.quantityLocal += 1
			this.handleEmitInput(this.quantityLocal)
		},

		handleDecrement () {
			if (this.quantityLocal <= 1) {
				this.quantityLocal = 1
			} else {
				this.quantityLocal -=1
			}
			this.handleEmitInput(this.quantityLocal)
		}
	}

}
</script>
<style scoped lang="scss">
.loader {
    color: getColor(primary);
    font-size: 16px;
    animation: rotator 1.4s linear infinite;
    outline: none;
    user-select: none;
    text-align: center;
    width: 47px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
}

.quantity-control {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: fit-content;
    background: getColor(input-background);
    border-radius: 10px;
    padding: calc($gutter / 2);
    margin: $gutter 0;
}

.quantity-btn {
    background: transparent;
    border: none;
    outline: none;
    margin: 0;
    padding: 0 calc($gutter / 2);
    cursor: pointer;
    color: getColor(text);

    &[disabled] {
        color: getColor(disabled-text) !important;
        cursor: not-allowed;
    }
}

.quantity-btn svg {
    width: 15px;
    height: 15px;
}

.quantity-input {
    outline: none;
    user-select: none;
    text-align: center;
    width: 47px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    color: getColor(text);
}

.quantity-input::-webkit-inner-spin-button,
.quantity-input::-webkit-outer-spin-button {
    appearance: none;
    margin: 0;
}

@keyframes rotator {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(270deg);
    }
}
</style>
